/**
 * Accordion JS functions
 */

const siteAccordions = () => {
  /**
   * Init foundation partners accordions
   */

  const accordions = document.querySelector(".section-foundations__grid");

  if (accordions !== null) {
    // User options
    new Accordion(".section-foundations__grid", {
      duration: 400,
      showMultiple: true,
      elementClass: "foundation",
      triggerClass: "foundation__header",
      panelClass: "foundation__content",
    });
  }

  /**
   * Init donateur template header accordion
   */

  const donateurAccordion = document.querySelector(".donateur-accordion");

  if (donateurAccordion !== null) {
    new Accordion(".donateur-accordion", {
      elementClass: "donateur-accordion__item",
      triggerClass: "donateur-accordion__item__header",
      panelClass: "donateur-accordion__item__content",
    });
  }

  /**
   * Init petition template accordion
   */
  const petitionAccordion = document.querySelector(".petition-content__accordion");

  if (petitionAccordion !== null) {
    new Accordion(".petition-content__accordion", {
      duration: 400,
      showMultiple: false,
      elementClass: "petition-accordion",
      triggerClass: "petition-accordion__header",
      panelClass: "petition-accordion__panel",
    });
  }
};
siteAccordions();
